import { ReactNode } from 'react';
import { Group, Paper, Stack, Switch, Text } from '@mantine/core';
import { primaryColor } from '../constants/theme';

interface NotificationToggleProps {
  icon: ReactNode;
  checked: boolean;
  loading: boolean;
  onChange: () => void;
  label: string;
  description: string;
  testId?: string;
}

export const NotificationToggle = ({
  icon,
  checked,
  loading,
  onChange,
  label,
  description,
  testId,
}: NotificationToggleProps) => {
  return (
    <Stack data-testid={testId}>
      <Paper p="md" withBorder>
        <Switch
          color={primaryColor}
          checked={checked}
          onChange={onChange}
          label={
            <Group gap="xs" align="center" wrap="nowrap">
              {icon}
              <span>{label}</span>
            </Group>
          }
          labelPosition="left"
          size="md"
          disabled={loading}
          styles={{ body: { justifyContent: 'space-between', width: '100%' } }}
          data-testid={testId ? `${testId}-switch` : undefined}
        />
        <Text size="sm" c="dimmed" mt="xs" ta="left" data-testid={testId ? `${testId}-description` : undefined}>
          {description}
        </Text>
      </Paper>
    </Stack>
  );
};
